import React from 'react';
import './Table.scss';
import '../PerformanceFrequency/FrequencyTable.scss';
import Button from '../../../components/Button';

const CopyTable = ({
  tableInstance,
  ColumnPicker,
  ShareButton,
  title,
  allowSummary,
  summaryData,
  summaryLoading,
  summaryError,
  fetchSummary,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { filters, selectedRowIds },
  } = tableInstance;

  let Display = null;

  if (summaryData) {
    Display = (
      <ul>
        {summaryData.map((rec) => {
          return (
            <li>
              <div className="bold-point">{rec.recommendation_bold_point}</div>
              <div className="description">
                {rec.recommendation_description}
              </div>
            </li>
          );
        })}
      </ul>
    );
  }

  if (summaryError) {
    Display = (
      <div>
        <i className="fa fa-exclamation-circle mr-2" />
        {`${
          summaryError.error.includes('context_length_exceeded')
            ? 'Error: This is more data than we currently support for BETA'
            : 'There was an error.'
        }`}
      </div>
    );
  }

  if (summaryLoading) {
    Display = (
      <div className="m-5 d-flex align-items-center justify-content-center w-100 text-center">
        <i
          className="fa-solid fa-spinner fa-spin"
          style={{ fontSize: '1.5rem', color: '#616161' }}
        />
      </div>
    );
  }

  return (
    <div className="copy-report-table">
      <div className="d-flex align-items-center">
        {ColumnPicker}
        {ShareButton ?? null}
      </div>
      <div className="report">
        {title && (
          <div className="report-header">
            <div className="report__title">{title}</div>
          </div>
        )}
        <div className="d-flex">
          <div className="report__table">
            <table {...getTableProps()} className={`frequency-table`}>
              <thead className="frequency-table__header">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => {
                      return (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          title={column.Header}
                          className={
                            column.isSorted
                              ? column.isSortedDesc
                                ? 'sorted-desc'
                                : 'sorted-asc'
                              : ''
                          }
                        >
                          <div className="table-header__text">
                            {column.render('Header')}
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? ' 🔽'
                                  : ' 🔼'
                                : ''}
                            </span>
                          </div>
                        </th>
                      );
                    })}
                  </tr>
                ))}
              </thead>
              {rows.length ? (
                <tbody {...getTableBodyProps()}>
                  {rows.map((row, i) => {
                    prepareRow(row);

                    return (
                      <tr
                        className="frequency-table__row"
                        {...row.getRowProps()}
                      >
                        {row.cells.map((cell) => {
                          return (
                            <td
                              className={`frequency-table__cell`}
                              {...cell.getCellProps()}
                            >
                              {cell.render('Cell')}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              ) : (
                <div className="d-flex flex-column align-items-center justify-content-center mx-auto w-100 mt-5">
                  <div className="no-data-face">
                    <span></span>
                    <span></span>
                  </div>
                  <h5 className="my-0 ml-3 mt-3">No data to display.</h5>
                </div>
              )}
            </table>
          </div>
          {allowSummary && (
            <div className="report__summary">
              <button onClick={fetchSummary} className="report__summary-button">
                <SparkleIcon />
                <span className="ml-2">
                  Use AI to summarize this data for me (BETA)
                </span>
                <i className="fa-solid fa-angle-right ml-4 pt-1" />
              </button>
              {Display}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CopyTable;

const SparkleIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.39776 9.81093C4.57396 9.93537 4.7845 10.0019 5.0002 10.0014C5.21591 10.0009 5.42611 9.93325 5.60169 9.80793C5.77968 9.67792 5.91467 9.4979 5.98867 9.28988L6.43564 7.91674C6.55034 7.57256 6.74348 7.25977 6.9998 7.00306C7.25611 6.74636 7.56859 6.55277 7.91256 6.43759L9.30348 5.98754C9.50912 5.91307 9.68622 5.77595 9.80983 5.59549C9.93343 5.41503 9.9973 5.20033 9.99244 4.98164C9.98758 4.76295 9.91423 4.5513 9.78274 4.3765C9.65125 4.20171 9.46823 4.07259 9.25948 4.00734L7.88456 3.55929C7.54025 3.4447 7.22731 3.2516 6.97047 2.99523C6.71362 2.73887 6.51991 2.42627 6.40464 2.08214L5.95267 0.693997C5.87989 0.489489 5.74519 0.312753 5.56731 0.188377C5.38943 0.0640006 5.17721 -0.00183155 4.96017 3.87758e-05C4.74314 0.0019091 4.53209 0.0713889 4.35638 0.198812C4.18066 0.326236 4.04903 0.505267 3.97978 0.710999L3.52281 2.11114C3.40809 2.44604 3.21891 2.75055 2.96949 3.00174C2.72008 3.25292 2.41694 3.44424 2.08289 3.56129L0.69297 4.00834C0.488578 4.08128 0.311964 4.21606 0.187648 4.39397C0.0633316 4.57188 -0.00251804 4.78408 -0.000759116 5.00113C0.000999812 5.21817 0.07028 5.42928 0.197463 5.60515C0.324646 5.78102 0.503421 5.91292 0.708969 5.98254L2.08289 6.42758C2.42894 6.54244 2.74322 6.73692 3.00043 6.99539C3.25763 7.25386 3.4506 7.56909 3.56381 7.91574L4.01578 9.30688C4.08778 9.5109 4.22177 9.68692 4.39776 9.81093ZM4.48275 2.39517L5.00972 1.01803L5.4497 2.39517C5.61321 2.8883 5.88981 3.33633 6.25738 3.70343C6.62495 4.07054 7.0733 4.34655 7.56658 4.50939L8.9725 5.03944L7.59058 5.48649C7.09772 5.65059 6.64993 5.92741 6.2828 6.29495C5.91566 6.66249 5.63931 7.11062 5.4757 7.6037L4.95273 8.98185L4.50375 7.6027C4.34241 7.1098 4.06853 6.66125 3.7038 6.29257C3.33449 5.9249 2.88563 5.64705 2.39187 5.48049L1.01395 4.95843L2.39987 4.50839C2.88647 4.33981 3.32781 4.06162 3.6898 3.6953C4.049 3.32746 4.32012 2.88294 4.48275 2.39517ZM10.5344 13.8533C10.6367 13.9253 10.7543 13.9724 10.8779 13.991C11.0016 14.0096 11.1279 13.9992 11.2468 13.9606C11.3657 13.922 11.474 13.8562 11.5632 13.7685C11.6523 13.6808 11.7198 13.5736 11.7603 13.4553L12.0083 12.6932C12.062 12.5353 12.1509 12.3917 12.2683 12.2732C12.3863 12.1532 12.5303 12.0652 12.6883 12.0132L13.4602 11.7611C13.6195 11.7061 13.7574 11.6022 13.8542 11.4643C13.9509 11.3263 14.0017 11.1612 13.9991 10.9927C13.9966 10.8242 13.9409 10.6608 13.84 10.5258C13.7391 10.3908 13.5981 10.2911 13.4372 10.241L12.6733 9.99095C12.5153 9.93803 12.3718 9.84928 12.2538 9.73165C12.1359 9.61402 12.0467 9.4707 11.9933 9.31288L11.7413 8.5398C11.6872 8.3808 11.5845 8.24286 11.4476 8.14553C11.3107 8.0482 11.1467 7.99642 10.9788 7.99753C10.8108 7.99864 10.6475 8.05257 10.512 8.15169C10.3764 8.25082 10.2754 8.3901 10.2234 8.5498L9.97644 9.31188C9.9254 9.46866 9.83883 9.61151 9.72348 9.72931C9.60813 9.8471 9.46713 9.93664 9.31148 9.99095L8.53852 10.243C8.37948 10.2969 8.24143 10.3995 8.14394 10.5362C8.04645 10.673 7.99447 10.837 7.99535 11.0049C7.99624 11.1729 8.04995 11.3363 8.14887 11.472C8.2478 11.6078 8.38692 11.7089 8.54652 11.7611L9.30948 12.0082C9.46947 12.0622 9.61346 12.1512 9.73146 12.2692C9.85045 12.3882 9.93844 12.5322 9.98944 12.6912L10.2424 13.4653C10.2972 13.6218 10.3992 13.7574 10.5344 13.8533ZM9.62146 11.0601L9.44247 11.0021L9.62646 10.938C9.92896 10.8317 10.2033 10.6578 10.4285 10.4296C10.6537 10.2014 10.824 9.92481 10.9264 9.62091L10.9844 9.44289L11.0444 9.62391C11.1465 9.93043 11.3185 10.2089 11.547 10.4374C11.7754 10.6658 12.0538 10.8379 12.3603 10.94L12.5553 11.0031L12.3753 11.0631C12.0682 11.1654 11.7893 11.3381 11.5606 11.5673C11.332 11.7964 11.16 12.0758 11.0584 12.3832L10.9994 12.5642L10.9414 12.3842C10.8398 12.076 10.6676 11.7958 10.4384 11.566C10.2092 11.3363 9.92942 11.1633 9.62146 11.0611"
        fill="#1E2B4E"
      />
    </svg>
  );
};
